import { API_ENDPOINT } from './config';

const CMS_BASE = '/cms';
const CMS_ING_PROJECTS_BASE = `${CMS_BASE}/ing-projects`;

export const urlsIngProjects = {
  ingProjects: `${API_ENDPOINT}/ing-projects`,
  ingProjectsPublic: `${API_ENDPOINT}/ing-projects/public`,
  ingProjectsPublicDetail: (projectId) =>
    `${API_ENDPOINT}/ing-projects/public/${projectId}`,
  ingProjectsDetail: (projectId) => `${API_ENDPOINT}/ing-projects/${projectId}`,
  ingProjectsStudents: (projectId) =>
    `${API_ENDPOINT}/ing-projects/${projectId}/students`,
  ingProjectsSettings: `${API_ENDPOINT}/ing-projects-settings`,
  ingProjectsSettingsPrepareNewYear: `${API_ENDPOINT}/ing-projects-settings/prepare-new-year`,
  ingProjectsMyApplications: `${API_ENDPOINT}/ing-projects-my-applications`,
  ingProjectsMyApplicationsPdf: `${API_ENDPOINT}/ing-projects-my-applications/pdf`,
  ingProjectsAssigned: `${API_ENDPOINT}/ing-projects-assigned`,
  ingProjectsApplicationTeacherPriority: (applicationId) =>
    `${API_ENDPOINT}/ing-projects-applications/${applicationId}/teacher-priority`,
  ingProjectsArchive: (projectId) =>
    `${API_ENDPOINT}/ing-projects/${projectId}/archive`,
  ingProjectsApprove: (projectId) =>
    `${API_ENDPOINT}/ing-projects/${projectId}/approve`,
  ingProjectsReject: (projectId) =>
    `${API_ENDPOINT}/ing-projects/${projectId}/reject`,
  ingProjectsApplications: `${API_ENDPOINT}/ing-projects-applications`,
  ingProjectsApplicationDetail: (applicationId) =>
    `${API_ENDPOINT}/ing-projects-applications/${applicationId}`,
  ingProjectsStudentStatus: `${API_ENDPOINT}/ing-projects-student/status`,
  ingProjectsStudentLock: `${API_ENDPOINT}/ing-projects-student/lock`,
  ingProjectsStudentsLocked: `${API_ENDPOINT}/ing-projects-students/locked`,
  ingProjectsStudentUnlock: `${API_ENDPOINT}/ing-projects-student/unlock`,
  ingProjectsStudentsActive: `${API_ENDPOINT}/ing-projects-students/active`,
  ingProjectsAcceptedStudents: `${API_ENDPOINT}/ing-projects-accepted-students`,
  ingProjectsAcceptedStudentDetail: (id) =>
    `${API_ENDPOINT}/ing-projects-accepted-students/${id}`,
  ingProjectsStudentApplications: (studentId) =>
    `${API_ENDPOINT}/ing-projects-students/${studentId}/applications`,
  ingProjectsStudentActive: (id) =>
    id
      ? `${API_ENDPOINT}/ing-projects-student/active/${id}`
      : `${API_ENDPOINT}/ing-projects-student/active`,
  ingProjectsStudentsWithoutProjects: `${API_ENDPOINT}/ing-projects-students/without-projects`,
  ingProjectsAcceptedStudentsImport: `${API_ENDPOINT}/ing-projects-accepted-students/import`,
  ingProjectsAssignmentsStatus: `${API_ENDPOINT}/ing-projects-assignments/status`,
  ingProjectsAssignmentsAssign: `${API_ENDPOINT}/ing-projects-assignments/assign`,
  ingProjectsAssignmentsUnassign: `${API_ENDPOINT}/ing-projects-assignments/unassign`,
  ingProjectsAssignmentsMatrix: `${API_ENDPOINT}/ing-projects-assignments/matrix`,
  ingProjectsAssignmentsManualAssign: `${API_ENDPOINT}/ing-projects-assignments/manual-assign`,
  ingProjectsAssignmentsManualUnassign: `${API_ENDPOINT}/ing-projects-assignments/manual-unassign`,
  ingProjectsAssignmentsPublish: `${API_ENDPOINT}/ing-projects-assignments/publish`,
  ingProjectsChangeRequests: `${API_ENDPOINT}/ing-projects-change-requests`,
  ingProjectsChangeRequestsCount: `${API_ENDPOINT}/ing-projects-change-requests/count`,
  ingProjectsChangeRequestDetail: (id) =>
    `${API_ENDPOINT}/ing-projects-change-requests/${id}`,
  ingProjectsChangeRequestApprove: (id) =>
    `${API_ENDPOINT}/ing-projects-change-requests/${id}/approve`,
  ingProjectsChangeRequestReject: (id) =>
    `${API_ENDPOINT}/ing-projects-change-requests/${id}/reject`,
  ingProjectsChangeRequestToken: (action, token) =>
    `${API_ENDPOINT}/ing-projects-change-requests/token?action=${action}&token=${token}`,
  ingProjectsPanelStoryList: `${API_ENDPOINT}/ing-projects-panel-story-list`,
  ingProjectsPanelStory: (projectId) =>
    `${API_ENDPOINT}/ing-projects/${projectId}/panel-story`,
  ingProjectsSettingsExportPanelStory: `${API_ENDPOINT}/ing-projects-settings/export-panel-story`,
  ingProjectsSettingsExportPanelStoryMissing: `${API_ENDPOINT}/ing-projects-settings/export-panel-story-missing`,
};

export const routesIngProjects = {
  ingProjectsPublicList: '/inz-projekty',
  ingProjectsPublicDetail: (projectId) => `/inz-projekty/${projectId}`,
  cmsIngProjects: `${CMS_ING_PROJECTS_BASE}/projects`,
  cmsIngProjectsEdit: (projectId) =>
    `${CMS_ING_PROJECTS_BASE}/projects/edit/${projectId}`,
  cmsIngProjectsDetail: (projectId) =>
    `${CMS_ING_PROJECTS_BASE}/projects/${projectId}`,
  cmsIngProjectsStudents: (projectId) =>
    `${CMS_ING_PROJECTS_BASE}/projects/${projectId}/students`,
  cmsIngPorjectsActiveStudents: `${CMS_ING_PROJECTS_BASE}/students`,
  cmsIngProjectStudentsAdd: `${CMS_ING_PROJECTS_BASE}/students/create`,
  cmsIngProjectsCreate: `${CMS_ING_PROJECTS_BASE}/projects/create`,
  cmsIngProjectsSettings: `${CMS_ING_PROJECTS_BASE}/settings`,
  cmsIngProjectsMyApplications: `${CMS_ING_PROJECTS_BASE}/my-applications`,
  cmsIngProjectsAssigned: `${CMS_ING_PROJECTS_BASE}/assigned`,
  cmsIngProjectsStudentAssignment: `${CMS_ING_PROJECTS_BASE}/student-assignment`,
  cmsIngProjectsChangeRequests: `${CMS_ING_PROJECTS_BASE}/change-requests`,
  cmsIngProjectsPanelStory: (projectId) =>
    `${CMS_ING_PROJECTS_BASE}/projects/${projectId}/panel-story`,
};
